//** Constants Branches */
export const LIST_BRANCH_REQUEST = 'LIST_BRANCH_REQUEST'
export const LIST_BRANCH_SUCCESS = 'LIST_BRANCH_SUCCESS'
export const LIST_BRANCH_FAIL = 'LIST_BRANCH_FAIL'

export const LIST_BRANCH_SUMMARY_REQUEST = 'LIST_BRANCH_SUMMARY_REQUEST'
export const LIST_BRANCH_SUMMARY_SUCCESS = 'LIST_BRANCH_SUMMARY_SUCCESS'
export const LIST_BRANCH_SUMMARY_FAIL = 'LIST_BRANCH_SUMMARY_FAIL'

export const BRANCH_RESET = 'BRANCH_RESET'

export const CREATE_BRANCH_REQUEST = 'CREATE_BRANCH_REQUEST'
export const CREATE_BRANCH_SUCCESS = 'CREATE_BRANCH_SUCCESS'
export const CREATE_BRANCH_FAIL = 'CREATE_BRANCH_FAIL'

export const DETAIL_BRANCH_REQUEST = 'DETAIL_BRANCH_REQUEST'
export const DETAIL_BRANCH_SUCCESS = 'DETAIL_BRANCH_SUCCESS'
export const DETAIL_BRANCH_FAIL = 'DETAIL_BRANCH_FAIL'

export const UPDATE_BRANCH_REQUEST = 'UPDATE_BRANCH_REQUEST'
export const UPDATE_BRANCH_SUCCESS = 'UPDATE_BRANCH_SUCCESS'
export const UPDATE_BRANCH_FAIL = 'UPDATE_BRANCH_FAIL'

export const UPDATE_BRANCH_KIT_REQUEST = 'UPDATE_BRANCH_KIT_REQUEST'
export const UPDATE_BRANCH_KIT_SUCCESS = 'UPDATE_BRANCH_KIT_SUCCESS'
export const UPDATE_BRANCH_KIT_FAIL = 'UPDATE_BRANCH_KIT_FAIL'

export const GET_BRANCH_KIT_REQUEST = 'GET_BRANCH_KIT_REQUEST'
export const GET_BRANCH_KIT_SUCCESS = 'GET_BRANCH_KIT_SUCCESS'
export const GET_BRANCH_KIT_FAIL = 'GET_BRANCH_KIT_FAIL'

export const LIST_BRANCH_LAB_REQUEST = 'LIST_BRANCH_LAB_REQUEST'
export const LIST_BRANCH_LAB_SUCCESS = 'LIST_BRANCH_LAB_SUCCESS'
export const LIST_BRANCH_LAB_FAIL = 'LIST_BRANCH_LAB_FAIL'

export const DELETE_BRANCH_REQUEST = 'DELETE_BRANCH_REQUEST'
export const DELETE_BRANCH_SUCCESS = 'DELETE_BRANCH_SUCCESS'
export const DELETE_BRANCH_FAIL = 'DELETE_BRANCH_FAIL'

//* Constants Working Day & Hour */
export const BRANCH_LIST_WORKING_DAY_REQUEST = 'BRANCH_LIST_WORKING_DAY_REQUEST'
export const BRANCH_LIST_WORKING_DAY_SUCCESS = 'BRANCH_LIST_WORKING_DAY_SUCCESS'
export const BRANCH_LIST_WORKING_DAY_FAIL = 'BRANCH_LIST_WORKING_DAY_FAIL'

export const BRANCH_LIST_WORKING_DAY_RESET = 'BRANCH_LIST_WORKING_DAY_RESET'

export const CREATE_BRANCH_WORKING_HOUR_REQUEST =
  'CREATE_BRANCH_WORKING_HOUR_REQUEST'
export const CREATE_BRANCH_WORKING_HOUR_SUCCESS =
  'CREATE_BRANCH_WORKING_HOUR_SUCCESS'
export const CREATE_BRANCH_WORKING_HOUR_FAIL = 'CREATE_BRANCH_WORKING_HOUR_FAIL'

export const DETAIL_BRANCH_WORKING_HOUR_REQUEST =
  'DETAIL_BRANCH_WORKING_HOUR_REQUEST'
export const DETAIL_BRANCH_WORKING_HOUR_SUCCESS =
  'DETAIL_BRANCH_WORKING_HOUR_SUCCESS'
export const DETAIL_BRANCH_WORKING_HOUR_FAIL = 'DETAIL_BRANCH_WORKING_HOUR_FAIL'

export const UPDATE_BRANCH_WORKING_HOUR_REQUEST =
  'UPDATE_BRANCH_WORKING_HOUR_REQUEST'
export const UPDATE_BRANCH_WORKING_HOUR_SUCCESS =
  'UPDATE_BRANCH_WORKING_HOUR_SUCCESS'
export const UPDATE_BRANCH_WORKING_HOUR_FAIL = 'UPDATE_BRANCH_WORKING_HOUR_FAIL'

export const DELETE_BRANCH_WORKING_HOUR_REQUEST =
  'DELETE_BRANCH_WORKING_HOUR_REQUEST'
export const DELETE_BRANCH_WORKING_HOUR_SUCCESS =
  'DELETE_BRANCH_WORKING_HOUR_SUCCESS'
export const DELETE_BRANCH_WORKING_HOUR_FAIL = 'DELETE_BRANCH_WORKING_HOUR_FAIL'
